$ = require('jquery')

module.exports =
	init: (payload) ->
		{$target} = payload

		$menu = $('.js-menu')
		$menuList = $menu.parent().find('.js-menu-list')
		resizeTimer = null

		$menu
			.on 'click', ->
				$menuList.slideToggle()
				$menu.toggleClass('is-down')

		if $(window).width() < 750
			$menuList.hide()


		$(window)
			.on('resize', ->
				if resizeTimer
					clearTimeout(resizeTimer)

				resizeTimer = setTimeout(->
					if $(window).width() < 750
						$menuList.hide()
					else
						$('.m-main').removeClass('is-open')
				, 200)
			)

		# if $(window).width() >= 1320
		# 	$('.b-intro').css('margin-bottom', $menuList.outerHeight() - $('.b-intro').outerHeight() - 28)

		$(window)
			.on('resize', ->
				if $(window).width() >= 1320
					$('.b-intro').css('margin-bottom', $menuList.outerHeight() - $('.b-intro').outerHeight() - 28)
				else
					$('.b-intro').css('margin-bottom', '20px')
			)

		return


// WEBPACK FOOTER //
// ./src/js/components/menu.coffee